import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Chip,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

const DomaineSouDomaineResume = ({ domaine_sous_domaines, loading }) => {
  const totalSousDomaines =
    domaine_sous_domaines?.reduce(
      (total, domaine) => total + (domaine?.sous_domaines?.length || 0),
      0
    ) || 0;

  return (
    <Grid item xs={12}>
      <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          sx={{ mb: 2 }}
        >
          <Stack direction="row" spacing={1.25} alignItems="center">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "primary.main",
                backgroundColor: "#EAF2FF",
              }}
            >
              <FolderOutlinedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={800}>
                Domaines et sous-domaines assignés
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Répartition des domaines retenus
              </Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip
              size="small"
              label={`${domaine_sous_domaines?.length || 0} domaine${
                (domaine_sous_domaines?.length || 0) > 1 ? "s" : ""
              }`}
              variant="outlined"
              color="primary"
            />
            <Chip
              size="small"
              label={`${totalSousDomaines} sous-domaine${
                totalSousDomaines > 1 ? "s" : ""
              }`}
              variant="outlined"
            />
          </Stack>
        </Stack>

        {loading && (
          <Stack spacing={1.5}>
            {[1, 2, 3].map((item) => (
              <Skeleton key={item} variant="rectangular" height={58} sx={{ borderRadius: 2 }} />
            ))}
          </Stack>
        )}

        {!loading && domaine_sous_domaines?.length > 0 && (
          <Stack spacing={1.25}>
            {domaine_sous_domaines.map((domaine, index) => (
              <Accordion
                key={index}
                defaultExpanded
                disableGutters
                elevation={0}
                sx={{
                  border: 1,
                  borderColor: "divider",
                  borderRadius: "8px !important",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    minHeight: 56,
                    backgroundColor: "#F8FAFC",
                    "& .MuiAccordionSummary-content": { alignItems: "center" },
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    spacing={1}
                    sx={{ width: "100%", pr: 1 }}
                  >
                    <Typography variant="body1" fontWeight={800}>
                      {domaine?.name || "Domaine non spécifié"}
                    </Typography>
                    <Chip
                      size="small"
                      color= {domaine?.sous_domaines?.length > 0 ? "primary" : "error"}
                      label={`${domaine?.sous_domaines?.length || 0} sous-domaine${
                        (domaine?.sous_domaines?.length || 0) > 1 ? "s" : ""
                      }`}
                      variant="outlined"
                    />
                  </Stack>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 2 }}>
                  {domaine?.sous_domaines?.length > 0 ? (
                    <Grid container spacing={1}>
                      {domaine.sous_domaines.map((sous_domaine, idx) => (
                        <Grid item key={idx}>
                          <Chip
                            label={sous_domaine.name || "Non spécifié"}
                            variant="outlined"
                            sx={{ backgroundColor: "#FFFFFF", fontWeight: 600 }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Alert severity="warning" variant="outlined">
                      Aucun sous-domaine assigné pour ce domaine.
                    </Alert>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        )}

        {!loading && (!domaine_sous_domaines || domaine_sous_domaines.length === 0) && (
          <Alert severity="info" variant="outlined">
            Aucun domaine assigné.
          </Alert>
        )}
      </Paper>
    </Grid>
  );
};

export default DomaineSouDomaineResume;
